module.exports = __webpack_public_path__ + "img/farm05.db8466d3.jpg";